import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    container:
      'flex h-[405px] w-full flex-col justify-center gap-16 bg-[image:var(--footer-bg-sm)] bg-cover bg-center px-3 py-[30px] md:h-[210px] md:gap-8 md:bg-[image:var(--footer-bg-md)] lg:px-[58px] lg:pt-0',
    top: 'flex flex-wrap justify-between gap-8',
    bottom: 'flex flex-col-reverse justify-between gap-4 md:flex-row md:gap-6',
    logo: 'flex items-center gap-2',
    logoImage: 'max-md:max-w-[170px]',
    text: 'pl-1 text-xl leading-[1] font-light tracking-[0.05em] text-white uppercase md:pl-2 md:tracking-[0.09em]',
    list: 'flex flex-wrap gap-2 pt-[5px] text-sm leading-[1.5] font-light lg:gap-8',
    listItem: 'w-full text-white md:w-auto',
    link: 'underline underline-offset-[3px]',
    contacts: 'flex flex-col items-start gap-1 md:items-end',
    phone:
      'text-xl leading-[1.5] font-semibold whitespace-nowrap text-white lg:text-[22px]',
    email:
      'text-[14px] leading-[1.5] font-light whitespace-nowrap text-white lg:text-[16px]',
    footnotes:
      'mt-5 mb-11 flex max-w-218 flex-col gap-3 px-3 text-[#747D81] lg:my-11 lg:pl-[49px]',
    footnote: 'text-[11px] leading-[1.3] font-light'
  }
});
